import { Directive, ElementRef, Input, OnInit } from '@angular/core';


@Directive({
  selector: '[appTippy]'
})
export class TippyDirective implements OnInit{



  constructor(private el: ElementRef) {
    this.el = el;
  }

  public ngOnInit() {
   
  }
  public ngAfterViewInit() {
    
  }

}
